module.exports = __webpack_public_path__ + "static/media/bugview.4833f7e3.png";